// extracted by mini-css-extract-plugin
export default {"root":"Dialog_root__W7bP4","paper":"Dialog_paper__4H1b8","close":"Dialog_close__QIsEX"};